import React, { Component } from 'react';

import banner from '../../img/banner-img.png';
import {Link} from "react-router-dom";
import PropTypes from "prop-types";
import {connect} from "react-redux";

class BannerHome extends Component {

    render() {
        return (
            <>
                {/*start banner Area*/}
                <section className="home-banner-area">

                    <div className="banner-bg">
                        <div className="banner-bg-first"> </div>
                        <div className="banner-bg-second"> </div>
                    </div>

                    <div className="container">
                        <div className="row fullscreen d-flex align-items-center">
                            <div className="banner-content col-lg-6 col-md-12 justify-content-center ">
                                <div className="me wow fadeInDown" data-wow-duration="1s" data-wow-delay="1.2s">C'est moi</div>
                                <h1 className="wow fadeInUp" data-wow-duration="1s" data-wow-delay="1.7s">{ this.props._preferences._author }</h1>
                                <div className="designation mb-50 wow fadeInUp" data-wow-duration="1s" data-wow-delay="2.1s">
                                    Développeur { " " }
                                    <span className="web">Web</span>
                                    { " " } et { " " }
                                    <span className="software">Logiciel</span>
                                </div>
                                <Link to="/portfolio" className="primary-btn" data-text="Portfolio">
                                    { "Portfolio".split("").map((rows, keys) => <span key={ keys }>{ rows }</span>) }
                                </Link>
                            </div>
                            <div className="banner-img col-lg-6 col-md-6 align-self-end">
                                <img className="img-fluid" src={ banner } alt="" /> {/* recommanded size 535x703 */}
                            </div>
                        </div>
                    </div>
                </section>
                {/*End banner Area*/}
            </>
        )
    }
}

BannerHome.protoType = {
    _preferences: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    _preferences: state._preferences
});

export default connect(
  mapStateToProps,
  { }
)(BannerHome);